/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/blog-slider.js":
/*!*******************************!*\
  !*** ./src/js/blog-slider.js ***!
  \*******************************/
/***/ (() => {

$(document).ready(function () {
  var blog_slider = document.querySelector('.blog-slider');
  if (!blog_slider) return;
  if (blog_slider) {
    var desktop_number = blog_slider.getAttribute('data-per-row');
    var tablet_number = blog_slider.getAttribute('data-per-row-tablet');
    var mobile_number = blog_slider.getAttribute('data-per-row-mobile');
    $('.slick-blog').slick({
      dots: false,
      arrows: true,
      nextArrow: '<button class="btn-next"><i class="theme-iconnext"></i></button>',
      prevArrow: '<button class="btn-prev"><i class="theme-iconback"></i></button>',
      speed: 300,
      rows: 1,
      centerPadding: '0',
      centerMode: true,
      slidesToShow: desktop_number,
      autoplay: true,
      responsive: [{
        breakpoint: 980,
        // tablet breakpoint
        settings: {
          slidesToShow: tablet_number,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 480,
        // mobile breakpoint
        settings: {
          slidesToShow: mobile_number,
          slidesToScroll: 1
        }
      }]
    });
  }
});

/***/ }),

/***/ "./src/js/theme.js":
/*!*************************!*\
  !*** ./src/js/theme.js ***!
  \*************************/
/***/ (() => {

if ($(window).width() > 1024) {
  var slick_slide = $('.blog-slider.blog-style-featured .slick-slide');
  for (var i = 0; i < slick_slide.length; i++) {
    var href = $(slick_slide[i]).hasClass('slick-current');
    if (!href) {
      $(slick_slide[i]).addClass('col-right-blog');
    }
  }
  setInterval(function () {
    var height_blog_left = $('.blog-slider.blog-style-featured .slick-slide.slick-current.slick-active').height();
    $('.blog-slider.blog-style-featured .slick-slide.col-right-blog.slick-active .col-right ').css('height', height_blog_left - 30);
    $('.blog-slider.blog-style-featured .slick-slide.col-right-blog.slick-active .col-right .post-image ').css('height', height_blog_left - 30);
  }, 100);
  $(window).resize(function () {
    var height_blog_left = $('.blog-slider.blog-style-featured .slick-slide.slick-current.slick-active').height();
    $('.blog-slider.blog-style-featured .slick-slide.col-right-blog.slick-active .col-right').css('height', height_blog_left - 30);
    $('.blog-slider.blog-style-featured .slick-slide.col-right-blog.slick-active .col-right .post-image ').css('height', height_blog_left - 30);
  });
}

//fix load image product slider
window.addEventListener('DOMContentLoaded', function () {
  var grid_slider = document.querySelector('.loading-slider');
  if (grid_slider) {
    var items = grid_slider.querySelectorAll('.item');
    if (grid_slider) {
      if (items.length > 0) {
        items.forEach(function (item) {
          item.classList.remove('hidden');
        });
      }
      grid_slider.style.maxHeight = grid_slider.scrollHeight + 'px';
    }
  }
  ;
});

/***/ }),

/***/ "./src/sass/main.scss":
/*!****************************!*\
  !*** ./src/sass/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/theme": 0,
/******/ 			"assets/main.min": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshopify_lusion"] = self["webpackChunkshopify_lusion"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main.min"], () => (__webpack_require__("./src/js/blog-slider.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/main.min"], () => (__webpack_require__("./src/js/theme.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main.min"], () => (__webpack_require__("./src/sass/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;